import s from "styled-components";
import { CircleButton } from "_c/button";

export const Master = s.button`
  outline: none;
  margin-right: 5px;
  img {
    border-width: 3px;
    border-style: solid;
    border-color: ${({ selected }) =>
      selected ? "var(--color-cta)" : "transparent"};
    transition: border-color .3s ease;
  }
`;
export const Wrap = s.div`
  display: flex;
  align-items: center;
  @media(max-width: 550px) {
    margin-top: 10px;
    justify-content: center;
  }
`;
export const RestButton = s(CircleButton)`
  span {
    font-size: 18px;
    padding-bottom: 8px;
  }
`;
export const RestContainer = s.div`
  padding: 5px 0;
  text-align: left;
  max-width: 320px;
  white-space: nowrap;
  overflow-x: auto;
  ::-webkit-scrollbar-track {
    background-color: white;
    border-radius: 45px;
  }
  ::-webkit-scrollbar {
    height: 5px;
    background-color: #fff;
    border-radius: 45px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(55deg, #a921dd 0%, #e71580 100%);
    border-radius: 45px;
  }
`;
